import { useSyncExternalStore } from "react";
import { useSearchParams } from "react-router-dom";

const subscribe = () => () => {};
const client = () => true;
const server = () => false;
const empty = new URLSearchParams();

/** Prerendered HTML has no query. Read the browser's query after hydration, then follow navigation. */
export function useHydratedSearchParams() {
    const [params, setParams] = useSearchParams();
    const hydrated = useSyncExternalStore(subscribe, client, server);
    return [hydrated ? params : empty, setParams] as const;
}
